module.exports = __webpack_public_path__ + "static/media/congnitoryadvisory.bd606f44.jpg";